import { BrokenImage } from '@components/index';
import styled from 'styled-components';

export const Overlay = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-content: center;
  justify-content: center;
  z-index: 899;
  background: #0000003d 0 0 no-repeat padding-box;
  opacity: 1;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
`;

interface IContainer {
  isLarger?: boolean;
}

export const Container = styled.div<IContainer>`
  padding: 16px 25px;
  padding-bottom: 24px;
  width: 970px;
  height: ${({ isLarger }) => (isLarger ? '658px' : '600px')};
  display: flex;
  align-self: center;
  justify-self: center;
  flex-direction: column;
  z-index: 100;
  position: fixed;

  background: #ffffff 0 0 no-repeat padding-box;
  box-shadow: 0 9px 26px #0000003d;
  border-radius: 16px;
  opacity: 1;
  animation: show 0.2s;
  transform: scale(1);
  @keyframes show {
    from {
      transform: scale(0);
      opacity: 0;
      z-index: -1;
    }
    to {
      transform: scale(1);
      opacity: 1;
      z-index: 2;
    }
  }
`;

export const Header = styled.div`
  flex: 1;
  font-weight: 600;
  font-size: 18px;
  color: #1b203a;
`;

export const CloseButton = styled.button`
  display: flex;
  cursor: pointer;
  border: 0;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  padding: 0;
  padding-top: 6px;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

export const CleanButton = styled.button`
  display: flex;
  cursor: pointer;
  border: 0;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 4px;
  width: 24px;
  height: 24px;
  padding: 0;
  padding-top: 2px;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

export const HeaderBar = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 16px;
`;

export const Body = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const Buttons = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 28px;
  gap: 8px;
`;

export const Description = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: #474d66;
`;

export const ButtonSimple = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 16px;
  height: 42px;
  color: #474d66;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  user-select: none;
`;

interface IButtonMain {
  disabled?: boolean;
}

export const ButtonMain = styled.div<IButtonMain>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 16px;
  height: 42px;
  background: ${({ disabled }) => (disabled ? '#EDEFF4' : '#1371fe')};
  color: ${({ disabled }) => (disabled ? '#C1C4D6' : '#fff')};
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  user-select: none;
`;

export const Inputs = styled.div`
  margin-top: 16px;
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const InputContainer = styled.div`
  flex: 1;
  height: 42px;
  position: relative;
  display: flex;
  align-items: center;
`;

export const IconLeft = styled(BrokenImage)`
  position: absolute;
  left: 7px;
  height: 28px;
  width: 28px;
  border: 1px solid #d8dae5;
  border-radius: 4px;
  object-fit: cover;
  -webkit-user-drag: none;
  user-select: none;
  padding: 2px;
`;

export const GlassIcon = styled.div`
  height: 24px;
  position: absolute;
  left: 17px;
`;

export const CleanSearch = styled.div`
  position: absolute;
  right: 10px;
`;

export const Skipped = styled.div`
  position: absolute;
  right: 12px;
  font-weight: 400;
  font-size: 14px;
  color: #8f95b2;
`;

interface IInput {
  isSearch?: boolean;
}

export const Input = styled.input<IInput>`
  flex: 1;
  height: 100%;
  width: 100%;
  border: 1px solid #d8dae5;
  background: ${({ disabled }) => (disabled ? '#F5F7FB' : '#fff')};
  border-radius: 8px;
  color: #474d66;
  font-weight: 400;
  font-size: 14px;
  padding-left: ${({ isSearch }) => (isSearch ? '36px' : '44px')};
  padding-right: 44px;
  padding-top: 2px;

  ::placeholder {
    color: #8f95b2;
  }
`;

export const ResultsText = styled.div`
  margin-top: 17px;
  font-weight: 400;
  font-size: 12px;
  color: #696f8c;
  margin-bottom: 4px;
`;

export const ScrollView = styled.div`
  flex: 1;
  width: 100%;

  overflow-y: overlay;

  ::-webkit-scrollbar {
    width: 24px;
    height: 24px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: #fff;
  }
`;

export const LoadMore = styled.div`
  margin-top: 6px;
  display: flex;
  width: 100%;
  align-items: center;
  justify-items: center;
  justify-content: center;
  align-content: center;
  flex-direction: row;
`;

export const LoadMoreContainer = styled.div`
  width: 100%;
`;

export const LoadingText = styled.div`
  border-radius: 8px;
  margin-right: 8px;
  border: none;
  font-size: 12px;
  color: #696f8c;
  text-align: center;
`;

export const LoadingImg = styled.img`
  height: 14px;
  width: 14px;
`;

export const ManufacturerContainer = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 13px;
  padding: 12px 16px;

  & + & {
    border-top: 1px solid #e6e8f0;
  }
`;

export const ProductTitles = styled.div`
  margin-top: 10px;
  display: grid;
  grid-template-columns: 3fr 1fr 1fr 1fr;
  gap: 13px;
  padding: 0 16px;
  padding-bottom: 6px;
  border-bottom: 1px solid #e6e8f0;
`;

export const TitleTableSpace = styled.div`
  width: 72px;
`;

export const TitleTable = styled.div`
  font-weight: 400;
  font-size: 12px;
  color: #696f8c;
  display: flex;
  align-items: center;
`;

export const ProductContainer = styled.div`
  cursor: pointer;
  display: grid;
  grid-template-columns: 3fr 1fr 1fr 1fr;
  gap: 13px;
  padding: 12px 16px;

  & + & {
    border-top: 1px solid #e6e8f0;
  }
`;

export const ProductValue = styled.div`
  display: flex;
  align-items: center;
  gap: 13px;
`;

interface IRadio {
  active: boolean;
}

export const Radio = styled.div<IRadio>`
  width: 16px;
  min-width: 16px;
  height: 16px;
  border-radius: 8px;
  border: ${({ active }) =>
    active ? '4px solid #1371fe' : '1px solid #d8dae5'};
  background-color: #fff;
  transition: 0.2s;
`;

export const ItemImage = styled(BrokenImage)`
  height: 30px;
  width: 30px;
  border: 1px solid #d8dae5;
  border-radius: 4px;
  object-fit: cover;
  -webkit-user-drag: none;
  user-select: none;
  padding: 2px;
`;

export const ItemName = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: #474d66;
  flex: 1;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const ItemEmpty = styled.div`
  color: #c1c4d6;
  font-size: 14px;
  font-weight: 400;
  font-style: italic;
`;

export const FullDetailsButton = styled.div`
  cursor: pointer;
  height: 32px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  border: 1px solid #d8dae5;
  border-radius: 6px;
  font-weight: 500;
  font-size: 14px;
  color: #474d66;
  white-space: nowrap;
  user-select: none;
`;

export const InternalContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const InternalText = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: #8f95b2;
`;

export const LoadingSearch = styled.img`
  height: 20px;
  width: 20px;
  position: absolute;
  right: 10px;
`;

export const AssetContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0 12px;
  gap: 24px;
  height: 42px;
  background: #f9fafc;
  border-radius: 6px;
  margin-top: 16px;
`;

export const AssetContent = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;

export const AssetTitle = styled.div`
  font-weight: 400;
  font-size: 12px;
  color: #696f8c;
  white-space: nowrap;
  padding-top: 2px;
`;

export const AssetField = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: #1b203a;
  margin-left: 12px;
  margin-right: 4px;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const AssetIcon = styled.div`
  height: 24px;
`;

export const AssetEmpty = styled.div`
  color: #c1c4d6;
  font-size: 14px;
  font-weight: 400;
  font-style: italic;
  margin-left: 12px;
  margin-right: 8px;
`;
